import React from 'react';
import Img from 'gatsby-image';
import styled from 'styled-components';
import colors from '../styles/colors';

const BaseHero = ({ heroImage, className, content, content2 }) => (
  <div className={className}>
    <div className='hero-container'>
      <div className="hero-heading-container text-center">
        <h1 className='heading'>
          {content}
          <br />
          {content2}
        </h1>
      </div>
      {heroImage && <Img className="hero-img" fluid={heroImage} />}
    </div>
  </div>
);

const HeroHeader = styled(BaseHero)`
  position: relative;
  width: 100%;

  div.hero-container {
    position: relative;
    width:100%;
    /* position: absolute;
    top: 35%;
    left: 50%;
    transform: translateX(-65%) translateY(-15%);
    z-index: 100;
    margin: 5px;
    max-width: 750px;
    margin: 0;
    padding: 0; */
  }

  .hero-heading-container {
    position: absolute;
    top:35%;
    left: 20%;
    width: 60%;
    z-index: 999;
    
    text-align: center;
    margin: 0 auto;
  }
  .hero-img {
    position: relative;
    z-index: 998;
  }

  h1 {
    margin: 0 auto;
    color: white;
    text-shadow: 1px 1px 10px ${colors.headingTextShadowGrey};
    text-align: center;
    text-transform: uppercase;
    font-size: 4.5vw;
    @media screen and (min-width: 1438px){
      font-size: 4rem
    }
    width: 100%;
    border-top: 0.4vw solid white;
    border-bottom: 0.4vw solid white;
    
    /* max-width: 1000px;
    color: white;
    text-shadow: 1px 1px 10px ${colors.headingTextShadowGrey};
    text-align: center;
    text-transform: uppercase;
    font-size: 4.5vw;
    border-top: 0.4vw solid white;
    border-bottom: 0.4vw solid white;
    padding-top: 5px;
    padding-bottom: 5px;
    margin: 0;
    margin-bottom: 10%;
    @media screen and (min-width: 1438px){
      font-size: 5rem
    } */
  }
`;

export default HeroHeader;
